import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Grid, IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { API_BASE_URL } from '../services/fetchData';
import { useAppContext } from '../contexts/AppContext';
import { useAlerta } from '../contexts/AlertaContext';
import Alerta from '../components/alerta/Alerta';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const WhiteCalendarIcon = (props) => (
    <CalendarMonthIcon {...props} sx={{ color: '#ffffff !important' }} />
);

export default function CertamenValores() {
    const { userData } = useAppContext();
    const showAlerta = useAlerta();

    const [formulario, setFormulario] = useState({
        nombre: '',
        categoria: '',
        provincia: '',
        localidad: '',
        codigoPostal: '',
        domicilio: '',
        telefono: '',
        email: '',
        foto: [],
        cv: [],
        canciones: [{ autor: '', titulo: '', url_video: '' }, { autor: '', titulo: '', url_video: '' }],
    });

    const [artista, setArtista] = useState({
        apellido: '',
        nombre: '',
        dni: '',
        fechaNacimiento: '',
    });

    const [open, setOpen] = useState(false);
    const [resetKey, setResetKey] = useState(0);

    const [artistas, setArtistas] = useState([]);

    useEffect(() => {
        document.title = "Certamen Nuevos Valores";
    }, []);

    // Certamen 2026: No requiere autenticación CIDI
    // Los usuarios pueden completar el formulario sin iniciar sesión

    useEffect(() => {
        // Autocompletar datos solo si el usuario está logueado (opcional)
        if (userData) {
            setFormulario(prev => ({
                ...prev,
                nombre: `${userData.Nombre} ${userData.Apellido}`,
                email: userData.Email || '',
                telefono: userData.CelFormateado || '',
                provincia: userData.Domicilio?.Provincia || '',
                localidad: userData.Domicilio?.Localidad || '',
                codigoPostal: userData.Domicilio?.CodigoPostal || '',
                domicilio: userData.Domicilio ? `${userData.Domicilio.Calle} ${userData.Domicilio.Altura}`.trim() : '',
            }));

            // Agregar al usuario como primer artista si la lista está vacía
            const fechaParts = userData.FechaNacimiento ? userData.FechaNacimiento.split(' ')[0].split('/') : null;
            const fechaISO = fechaParts ? `${fechaParts[2]}-${fechaParts[1]}-${fechaParts[0]}` : '';

            setArtistas([{
                apellido: userData.Apellido || '',
                nombre: userData.Nombre || '',
                dni: userData.NroDocumento || '',
                fechaNacimiento: fechaISO,
            }]);
        }
    }, [userData]);

    const handleChange = (field) => (event) => {
        setFormulario({ ...formulario, [field]: event.target.value });
    };

    const handleArtistaChange = (field) => (event) => {
        setArtista({ ...artista, [field]: event.target.value });
    };

    const handleFileChange = (field) => (event) => {
        setFormulario({ ...formulario, [field]: event.target.files });
    };

    const handleAddArtista = () => {
        if (!artista.apellido || !artista.nombre || !artista.dni || !artista.fechaNacimiento) {
            showAlerta('error', 'Todos los campos del artista son requeridos');
            return;
        }

        setArtistas([...artistas, { ...artista }]);
        setArtista({ apellido: '', nombre: '', dni: '', fechaNacimiento: '' });
    };

    const handleDeleteArtista = (index) => {
        const newArtistas = artistas.filter((_, i) => i !== index);
        setArtistas(newArtistas);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        let camposRequeridos = [
            { nombre: 'nombre', valor: formulario.nombre },
            { nombre: 'categoria', valor: formulario.categoria },
            { nombre: 'provincia', valor: formulario.provincia },
            { nombre: 'localidad', valor: formulario.localidad },
            { nombre: 'código postal', valor: formulario.codigoPostal },
            { nombre: 'domicilio', valor: formulario.domicilio },
            { nombre: 'teléfono ', valor: formulario.telefono },
            { nombre: 'correo electrónico', valor: formulario.email },

        ];

        for (let campo of camposRequeridos) {
            if (!campo.valor) {
                showAlerta('error', `El campo '${campo.nombre}' es requerido`);
                return;
            }
        }

        if (artistas.length === 0) {
            showAlerta('error', 'Debe agregar al menos un artista');
            return;
        }

        if (formulario.canciones.some(c => !c.autor || !c.titulo || !c.url_video)) {
            showAlerta('error', 'Todos los campos de ambas canciones son requeridos');
            return;
        }


        camposRequeridos = [{ nombre: 'foto', valor: formulario.foto[0] },
        { nombre: 'CV ', valor: formulario.cv[0] },
        ]

        for (let campo of camposRequeridos) {
            if (!campo.valor) {
                showAlerta('error', `El campo '${campo.nombre}' es requerido`);
                return;
            }
        }

        setOpen(true);
    }

    const handleConfirm = async () => {
        const formData = new FormData();
        formData.append('nombre', formulario.nombre);
        formData.append('categoria', formulario.categoria);
        formData.append('provincia', formulario.provincia);
        formData.append('localidad', formulario.localidad);
        formData.append('codigo_postal', formulario.codigoPostal);
        formData.append('domicilio', formulario.domicilio);
        formData.append('telefono', formulario.telefono);
        formData.append('email', formulario.email);
        formData.append('foto', formulario.foto[0]);
        formData.append('cv', formulario.cv[0]);

        formData.append('artistas', JSON.stringify(artistas.map(artista => ({
            apellido: artista.apellido,
            nombre: artista.nombre,
            dni: artista.dni,
            fecha_nacimiento: artista.fechaNacimiento ? dayjs(artista.fechaNacimiento).format('YYYY-MM-DD') : '',
        })
        )));
        formData.append('canciones', JSON.stringify(formulario.canciones));

        try {
            let response = await fetch(`${API_BASE_URL}postulacion/`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                showAlerta('success', 'Formulario enviado correctamente');
                setFormulario({
                    nombre: '',
                    categoria: '',
                    provincia: '',
                    localidad: '',
                    codigoPostal: '',
                    domicilio: '',
                    telefono: '',
                    email: '',
                    foto: [],
                    cv: [],
                    canciones: [{ autor: '', titulo: '', url_video: '' }, { autor: '', titulo: '', url_video: '' }],
                });
                setArtistas([]);
                setResetKey(prev => prev + 1);
            } else if (response.status === 413) {
                showAlerta('error', 'Los archivos son muy pesados. Por favor, reduzca su tamaño.');
            } else {
                showAlerta('error', 'Error al enviar el formulario');
            }
        } catch (error) {
            showAlerta('error', 'Error al enviar el formulario');
        }
    };

    const downloadPliego = () => {
        window.open("/nuevos_valores.pdf");
    }

 

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <style>
                {`
                    .MuiInputAdornment-root .MuiSvgIcon-root,
                    .MuiIconButton-root .MuiSvgIcon-root,
                    .MuiButtonBase-root.MuiIconButton-root {
                        color: #ffffff !important;
                    }
                `}
            </style>
            <Box sx={{
                width: { xs: '100%', sm: '70%' }, margin: '0 auto', boxSizing: 'border-box',
                display: 'flex', flexDirection: 'column', gap: '40px',
                mt: 3,
            }}>
                {/* <Box sx={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    borderRadius: '8px',
                    backdropFilter: 'blur(10px)',
                    p: 3,
                }}>
                    <Typography variant="h6" gutterBottom fontWeight={600}>Certamen Nuevos Valores del Canto y la Música</Typography>
                    <Typography variant="body1" gutterBottom sx={{ textAlign: 'justify', width: '100%' }}>
                        Si sos solista o tenés un conjunto musical (vocal o instrumental) podés estar en el Festival de Peñas Villa María 2026.
                    </Typography>
                    <Typography variant="body1" gutterBottom sx={{ textAlign: 'justify', width: '100%' }}>
                        Completá el formulario que se encuentra a continuación para enviar la postulación y un jurado técnico integrado por tres destacados especialistas evaluarán a los inscriptos y determinarán a los dos artistas (un solista y un conjunto musical) que participarán del 58º Festival de Festivales.
                    </Typography>
                    <Typography variant="body1" gutterBottom sx={{ textAlign: 'justify', width: '100%' }}>
                        Importante: Consultar las Bases y Condiciones, donde se detallan los requisitos de participación.
                    </Typography>
                    <Button variant="contained" sx={{
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        color: '#FFFFFF',
                        borderRadius: '8px',
                        px: '20px',
                        py: '10px',
                        fontSize: '20px',
                        fontWeight: 'bold',
                        backdropFilter: 'blur(10px)',
                        mt: '20px',
                        "&:hover": {
                            backgroundColor: '#D4A646',
                        }

                    }}
                        onClick={downloadPliego}
                    >
                        Bases y Condiciones
                    </Button>
                </Box> */}
                      <Typography variant="h6" gutterBottom fontWeight={600} sx={{
            textAlign: 'center',
            height: '300px',
            width: '100%',
            mt: 5,
        }}>
            Agradecemos a todos los que se han inscripto al certamen Nuevos Valores. A la brevedad, un jurado técnico y profesional estará anunciando los ganadores de cada categoría
        </Typography>
                {/* <Box component="form" onSubmit={handleSubmit} sx={{
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    borderRadius: '8px',
                    backdropFilter: 'blur(10px)',
                    p: 3,
                }}>
                    <Typography variant="h4" gutterBottom>Datos del Formulario</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth label="Nombre*" value={formulario.nombre} onChange={handleChange('nombre')} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField fullWidth label="Categoría*" value={formulario.categoria} onChange={handleChange('categoria')} />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                label="Provincia*"
                                value={formulario.provincia}
                                onChange={handleChange('provincia')}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                label="Localidad*"
                                value={formulario.localidad}
                                onChange={handleChange('localidad')}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                label="Código Postal*"
                                value={formulario.codigoPostal}
                                onChange={handleChange('codigoPostal')}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Domicilio*"
                                value={formulario.domicilio}
                                onChange={handleChange('domicilio')}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Teléfono*"
                                value={formulario.telefono}
                                onChange={handleChange('telefono')}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Correo Electrónico*"
                                value={formulario.email}
                                onChange={handleChange('email')}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6">Agregar Artista</Typography>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                mt: 2,
                                mb: 4
                            }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            fullWidth
                                            label="Apellido*"
                                            value={artista.apellido}
                                            onChange={handleArtistaChange('apellido')}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            fullWidth
                                            label="Nombre*"
                                            value={artista.nombre}
                                            onChange={handleArtistaChange('nombre')}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <TextField
                                            fullWidth
                                            label="DNI*"
                                            value={artista.dni}
                                            onChange={handleArtistaChange('dni')}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <DatePicker
                                            label="Nacimiento*"
                                            value={artista.fechaNacimiento ? dayjs(artista.fechaNacimiento) : null}
                                            onChange={(newValue) => {
                                                setArtista({ ...artista, fechaNacimiento: newValue ? newValue.toISOString() : '' });
                                            }}
                                            slots={{
                                                openPickerIcon: WhiteCalendarIcon
                                            }}
                                            slotProps={{
                                                openPickerButton: {
                                                    sx: {
                                                        color: '#ffffff !important',
                                                        '& .MuiSvgIcon-root': {
                                                            color: '#ffffff !important'
                                                        }
                                                    }
                                                },
                                                textField: { 
                                                    fullWidth: true,
                                                    InputProps: {
                                                        sx: {
                                                            '& .MuiInputAdornment-root .MuiSvgIcon-root': { color: '#ffffff !important' },
                                                            '& .MuiSvgIcon-root': { color: '#ffffff !important' }
                                                        }
                                                    }
                                                },
                                                popper: {
                                                    sx: {
                                                        '& .MuiPaper-root': {
                                                            backgroundColor: 'rgba(34, 0, 21, 0.95)',
                                                            backdropFilter: 'blur(10px)',
                                                            color: '#fff',
                                                            border: '1px solid rgba(255, 255, 255, 0.2)',
                                                            '& .MuiTypography-root': { color: '#fff' },
                                                            '& .MuiSvgIcon-root': { color: '#fff' },
                                                            '& .MuiPickersDay-root': { 
                                                                color: '#fff',
                                                                '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
                                                                '&.Mui-selected': { backgroundColor: '#D4A646' }
                                                            },
                                                            '& .MuiPickersYear-yearButton': { color: '#fff' },
                                                            '& .MuiPickersMonth-monthButton': { color: '#fff' },
                                                            '& .MuiDayCalendar-weekDayLabel': { color: 'rgba(255, 255, 255, 0.6)' }
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button 
                                            variant="contained" 
                                            fullWidth 
                                            sx={{
                                                height: "56px",
                                                backgroundColor: '#FFFFFF',
                                                color: '#000000',
                                                fontWeight: 'bold',
                                                '&:hover': {
                                                    backgroundColor: '#f2f2f2',
                                                }
                                            }} 
                                            onClick={handleAddArtista}
                                        >
                                            Agregar Artista
                                        </Button>
                                    </Grid>
                                </Grid>

                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                    {artistas.map((artista, index) => (
                                        <Grid container spacing={2} key={index} alignItems="center">
                                            <Grid item xs={12} sm={6} md={3}>
                                                <TextField
                                                    fullWidth
                                                    label="Apellido*"
                                                    value={artista.apellido}
                                                    onChange={(e) => {
                                                        const newArtistas = [...artistas];
                                                        newArtistas[index].apellido = e.target.value;
                                                        setArtistas(newArtistas);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <TextField
                                                    fullWidth
                                                    label="Nombre*"
                                                    value={artista.nombre}
                                                    onChange={(e) => {
                                                        const newArtistas = [...artistas];
                                                        newArtistas[index].nombre = e.target.value;
                                                        setArtistas(newArtistas);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <TextField
                                                    fullWidth
                                                    label="DNI*"
                                                    value={artista.dni}
                                                    onChange={(e) => {
                                                        const newArtistas = [...artistas];
                                                        newArtistas[index].dni = e.target.value;
                                                        setArtistas(newArtistas);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={2}>
                                                <DatePicker
                                                    label="Nacimiento*"
                                                    value={artista.fechaNacimiento ? dayjs(artista.fechaNacimiento) : null}
                                                    onChange={(newValue) => {
                                                        const newArtistas = [...artistas];
                                                        newArtistas[index].fechaNacimiento = newValue ? newValue.toISOString() : '';
                                                        setArtistas(newArtistas);
                                                    }}
                                                    slots={{
                                                        openPickerIcon: WhiteCalendarIcon
                                                    }}
                                                    slotProps={{
                                                        openPickerButton: {
                                                            sx: {
                                                                color: '#ffffff !important',
                                                                '& .MuiSvgIcon-root': {
                                                                    color: '#ffffff !important'
                                                                }
                                                            }
                                                        },
                                                        textField: { 
                                                            fullWidth: true,
                                                            InputProps: {
                                                                sx: {
                                                                    '& .MuiInputAdornment-root .MuiSvgIcon-root': { color: '#ffffff !important' },
                                                                    '& .MuiSvgIcon-root': { color: '#ffffff !important' }
                                                                }
                                                            }
                                                        },
                                                        popper: {
                                                            sx: {
                                                                '& .MuiPaper-root': {
                                                                    backgroundColor: 'rgba(34, 0, 21, 0.95)',
                                                                    backdropFilter: 'blur(10px)',
                                                                    color: '#fff',
                                                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                                                    '& .MuiTypography-root': { color: '#fff' },
                                                                    '& .MuiSvgIcon-root': { color: '#fff' },
                                                                    '& .MuiPickersDay-root': { 
                                                                        color: '#fff',
                                                                        '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
                                                                        '&.Mui-selected': { backgroundColor: '#D4A646' }
                                                                    },
                                                                    '& .MuiPickersYear-yearButton': { color: '#fff' },
                                                                    '& .MuiPickersMonth-monthButton': { color: '#fff' },
                                                                    '& .MuiDayCalendar-weekDayLabel': { color: 'rgba(255, 255, 255, 0.6)' }
                                                                }
                                                            }
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Tooltip title="Eliminar">
                                                    <IconButton onClick={() => handleDeleteArtista(index)}>
                                                        <DeleteIcon color='error' />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6">Canciones</Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                                {[0, 1].map((i) => (
                                    <Grid container spacing={2} key={i}>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                fullWidth
                                                label="Autor*"
                                                value={formulario.canciones[i].autor}
                                                onChange={(e) => {
                                                    const newCanciones = [...formulario.canciones];
                                                    newCanciones[i].autor = e.target.value;
                                                    setFormulario({ ...formulario, canciones: newCanciones });
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                fullWidth
                                                label="Título*"
                                                value={formulario.canciones[i].titulo}
                                                onChange={(e) => {
                                                    const newCanciones = [...formulario.canciones];
                                                    newCanciones[i].titulo = e.target.value;
                                                    setFormulario({ ...formulario, canciones: newCanciones });
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                fullWidth
                                                label="URL Audio*"
                                                value={formulario.canciones[i].url_video}
                                                onChange={(e) => {
                                                    const newCanciones = [...formulario.canciones];
                                                    newCanciones[i].url_video = e.target.value;
                                                    setFormulario({ ...formulario, canciones: newCanciones });
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                ))}
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Typography>Foto (PNG o JPG)*:</Typography>
                            <TextField
                                key={`foto-${resetKey}`}
                                type="file"
                                fullWidth
                                inputProps={{ accept: '.png,.jpg', multiple: true }}
                                onChange={handleFileChange('foto')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography>CV (PDF)*:</Typography>
                            <TextField
                                key={`cv-${resetKey}`}
                                type="file"
                                fullWidth
                                inputProps={{ accept: '.pdf' }}
                                onChange={handleFileChange('cv')}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button variant="contained"
                                type="submit"
                                sx={{
                                    backgroundColor: '#D4A646',
                                    color: '#FFFFFF',
                                    '&:hover': {
                                        backgroundColor: '#D4A646',
                                    },
                                    mt: 2,
                                    py: 1.5
                                }}
                                fullWidth>Enviar</Button>
                        </Grid>
                    </Grid>
                </Box> */}
            </Box >
            <Alerta open={open} setOpen={setOpen} severity={"info"} message={<Box sx={{
                mt: 2,
            }}>
                <Typography variant="body1" gutterBottom sx={{
                    color: "black",
                }}>
                    Al enviar el formulario, aceptás las <a href="/nuevos_valores.pdf" target="_blank">Bases y Condiciones</a> del Certamen Nuevos Valores del Canto y la Música.
                </Typography>

            </Box>} onClick={handleConfirm} />
        </LocalizationProvider>
    );
}
